/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';

const StudentDashboard = lazy(
  () => import('@/features/student/presentation/components/StudentDashboard'),
);
const CoursePlayer = lazy(() => import('@/features/student/presentation/components/CoursePlayer'));
const MyPurchases = lazy(() => import('@/features/payment/presentation/components/MyPurchases'));

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    Carregando...
  </div>
);

export const studentRoutes = [
  {
    path: 'dashboard-aluno',
    handle: { ds: 'nebi' },
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <StudentDashboard />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: 'course-player/:id',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <CoursePlayer />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: 'minhas-compras',
    handle: { ds: 'nebi' },
    element: (
      <ProtectedRoute>
        <Suspense fallback={<LoadingFallback />}>
          <MyPurchases />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];
